import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Pipeline Rows Update Step
 *
 * Bulk update the status (and optionally metadata) of pipeline rows.
 * Typically used after a downstream step has processed rows, to mark
 * them as completed, sent, etc.
 *
 * Example workflow:
 * ```
 * Pipeline Rows Query → [processing step] → Pipeline Rows Update (newStatus: "completed")
 * ```
 */
export const pipelineRowsUpdateStep = defineStepConfig({
  type: "pipeline_rows_update",
  name: "Update Pipeline Rows",
  description: "Bulk update the status and metadata of pipeline rows",
  category: "Data Access",

  inputSchema: z.object({
    rowIds: z.array(z.string()).describe("Pipeline row IDs to update"),
  }),

  outputSchema: z.object({
    updatedCount: z.number().describe("Number of rows updated"),
  }),

  configSchema: z.object({
    pipelineId: z.string().describe("Pipeline the rows belong to"),
    newStatus: z.string().describe("New status to assign"),
    statusReason: z
      .string()
      .optional()
      .describe("Reason for the status change"),
    mergeMetadata: z
      .record(z.string(), z.unknown())
      .optional()
      .describe("Key-value pairs to merge into row metadata"),
  }),

  emits: [] as const,
});
